import { defineStore } from 'pinia'
import { actions } from './actions'
import { QuizMainOnboardingStep } from './enums'
import { getters } from './getters'
import type { QuizMainStore } from './interfaces'

export const useQuizMainStore = defineStore('quiz-main-store', {
  state: (): QuizMainStore => {
    return {
      quizAbbr: 'quiz15',
      loader: false,
      processing: false,
      modalOtp: false,
      modalError: false,
      otpError: false,
      phoneNumber: null,
      linkAutologin: null,
      registeredCustomer: null,
      notification: {
        show: false,
        title: '',
        description: '',
        mode: 'info'
      },
      quizFinish: false,
      step: null,
      homeStep: null,
      extendedSlots: false,
      screenRecording: false,
      onboardingStep: QuizMainOnboardingStep.ScreenSuccessful,
      childrenLink: null,
      childrenLinkEla: null,
      firstChildName: null,
      secondChildTab: false,
      secondChildName: null,
      grade: null,
      firstChildDiscipline: null,
      email: null,
      secondChildGrade: null,
      reservedFirstTimeSlot: null,
      reservedSecondTimeSlot: null,
      additionalStoreLink: null,
      redirectStoreLink: null,
      answers: null,
      assessments: null,
      triggerShowNote: 0,
      zip: null,
      trackedViewContent: false,
      parentName: null,
      triggerOtpSuccessfullyVerified: 0,
      customerId: null,
      longBookingWindow: false,
      firstChildBookedTime: null,
      allSlots: [],
      tzSlots: [],
      lessonDates: [],
      loadedSlots: false,
      reservedFirstTimeSlotEla: null,
      reservedSecondTimeSlotEla: null,
      secondChildTabEla: false,
      propsInfo: {},
      bookingElaData: null,
      childrenPositionEla: 1,
      triggerChildrenPositions: 1,
      modalEla: false,
      timezone: '',
      timezoneAbbr: '',
      firstChildDisciplineMath: true,
      firstChildDisciplineReading: false,
      secondChildDisciplineMath: false,
      secondChildDisciplineReading: false,
      triggerValidateFirstChildForm: 0,
      triggerValidateSecondChildForm: 0,
      secondChildBooking: false
    }
  },
  getters: { ...getters },
  actions: { ...actions }
})
